import React, { Component } from 'react'
import MonthGraph from './MonthGraph'
import css from './BudgetPlanning.css'
type Props = {
  month: any
  data: any
  displayCumulativeValues: boolean
}
export default class GraphSection extends Component<Props> {
  render() {
    const { month, data, displayCumulativeValues } = this.props
    return (
      <React.Fragment>
        <div className={css.graphContainer}>
          <MonthGraph month={month} data={data} graphType={'sales'} displayCumulativeValues={displayCumulativeValues} />
        </div>
        <div className={css.graphContainer}>
          <MonthGraph month={month} data={data} graphType={'hours'} displayCumulativeValues={displayCumulativeValues} />
        </div>
        <div className={css.graphContainer}>
          <MonthGraph
            month={month}
            data={data}
            graphType={'efficiency'}
            displayCumulativeValues={displayCumulativeValues}
          />
        </div>
      </React.Fragment>
    )
  }
}
